import React from 'react';
import {
    SECONDARY_COLUMN,
    SECONDARY_COLUMN_LG,
    SECONDARY_COLUMN_XL,
} from '@/shared/utils/tableControls';
import './TableControls.css';

const DIRECTION_TEXT = { asc: 'sorted ascending', desc: 'sorted descending' };

/**
 * A column header. A sortable column holds a real button; `aria-sort` on the
 * cell tells assistive technology the current direction. `interactive={false}`
 * renders the plain label, for a table drawn as cards where another control
 * sorts. A `secondary` column is hidden below the md breakpoint (`'lg'`: below
 * lg, `'xl'`: below xl); its cells carry the same SECONDARY_COLUMN class. A column with
 * `align: 'end'` (a count) is right-aligned with tabular numerals; its cells
 * carry the same `table-num` class.
 */
export default function SortableTh({
    column,
    controls,
    interactive = true,
    className: extraClassName = undefined,
    role = undefined,
}) {
    const className =
        [
            extraClassName,
            column.align === 'end' && 'table-num',
            column.secondary &&
                ({ lg: SECONDARY_COLUMN_LG, xl: SECONDARY_COLUMN_XL }[
                    column.secondary
                ] ||
                    SECONDARY_COLUMN),
        ]
            .filter(Boolean)
            .join(' ') || undefined;
    const sortable = column.sortable !== false;
    if (!sortable || !interactive) {
        return (
            <th scope="col" className={className} role={role}>
                {column.label}
            </th>
        );
    }
    const active = controls.sort.key === column.key;
    const direction = active ? controls.sort.direction : 'none';
    return (
        <th
            scope="col"
            className={className}
            role={role}
            aria-sort={controls.ariaSort(column.key)}
        >
            <button
                type="button"
                className="table-sort-btn"
                data-sort={direction}
                onClick={() => controls.toggleSort(column.key)}
            >
                {column.label}
                {active && (
                    <span className="visually-hidden">
                        , {DIRECTION_TEXT[direction]}
                    </span>
                )}
            </button>
        </th>
    );
}
